import { keyBy } from 'lodash'
import { useMemo } from 'react'

const useListIndexed = (list = [], key = 'id') => {
    const object = useMemo(() => keyBy(list, key), [list, key])
    return object
}

export default useListIndexed